// TODO: Require Dependency
import React from "react";
import "babel-polyfill";
import { Switch } from "react-router-dom";
import { Provider } from "react-redux";
import store, { history } from "./Store";
import { ConnectedRouter } from "connected-react-router";

// TODO: Routes
import { PartnerAgreementRoutes } from "../PartnerAgreement/route";

export const Main = () => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Switch>
        <PartnerAgreementRoutes />
        {/*<Route component={ () => <ErrorComponent defaultError={404} /> } />*/}
      </Switch>
    </ConnectedRouter>
  </Provider>
);



// WEBPACK FOOTER //
// ./src/modules/Setup/MainRoute.js